var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[_vm.isbg && 'sdkdow_btn']},[_c('single-button',{attrs:{"text":_vm.text,"width":_vm.width,"height":_vm.height},on:{"know":_vm.download}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }